import bugsnag from 'bugsnag-js';

window.bugsnagClient = bugsnag({
  apiKey: '3f758c9b94b0b542974564e079b9493f',
  releaseStage: process.env.RAILS_ENV,
  notifyReleaseStages: ['production'],
});
